<template>
  <div class="home">
    <swiper ref="mySwiper" :options="swiperOption" @someSwiperEvent="callback">
      <swiper-slide>
        <first @jump="jump" />
      </swiper-slide>
      <swiper-slide>
        <second />
      </swiper-slide>
      <!-- <swiper-slide>
        <three />
      </swiper-slide> -->
      <swiper-slide ref="slide3">
        <four />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import first from '@/components/home-pages/first.vue'
import second from '@/components/home-pages/second.vue'
// import three from '@/components/home-pages/three.vue'
import four from '@/components/home-pages/four.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'carrousel',
  components: {
    first,
    second,
    // three,
    four,
    swiper,
    swiperSlide
  },
  data() {
    let that = this
    return {
      active: 0,
      city: '定位中',
      swiperOption: {
        direction: 'vertical',
        autoHeight: true, //高度随内容变化
        spaceBetween: 0,
        slideToClickedSlide: false,
        simulateTouch: false,//禁止鼠标模拟
        allowTouchMove: false,//设为false时，slide无法滑动
        mousewheel: {
          releaseOnEdges: true
        },
        on: {
          slideChange: function() {
            console.log('改变了，activeIndex为' + this.activeIndex)
            that.$store.commit('setActiveIndex', this.activeIndex)
          },
          reachEnd: function() {
            console.log('到了最后一个slide')
            let container = document.getElementsByClassName('swiper-container')[0]
            let slide = document.getElementsByClassName('swiper-slide')[2]
            container.style.height = 'auto'
            slide.style.height = 'auto'
          },
          resize: function() {
            this.params.width = window.innerWidth
            this.update()
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.$store.commit('setHomeSwiper', this.swiper)
  },
  created() {
    this.getLocation()
  },
  methods: {
    //跳转下一页
    jump() {
      this.swiper.slideNext()
    },
    // 高德定位
    getLocation() {
      var self = this
      AMap.plugin('AMap.Geolocation', function() {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000
        })

        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete)
        AMap.event.addListener(geolocation, 'error', onError)

        function onComplete(data) {
          // data是具体的定位信息
          console.log('定位成功信息：', data)
          self.$store.commit('setCity', data.addressComponent.city)
          self.$store.commit('setCityCode', parseInt(data.addressComponent.adcode))
          localStorage.setItem('cityCode', parseInt(data.addressComponent.adcode))
          localStorage.setItem('cityName', data.formattedAddress)
        }

        function onError(data) {
          // 定位出错
          console.log('定位失败错误：', data)
          self.getLngLatLocation()
        }
      })
    },
    getLngLatLocation() {
      var self = this
      AMap.plugin('AMap.CitySearch', function() {
        var citySearch = new AMap.CitySearch()
        citySearch.getLocalCity(function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 查询成功，result即为当前所在城市信息
            console.log('通过ip获取当前城市：', result)
            console.log(2222, self.$store)

            self.$store.commit('setCity', result.city)
            self.$store.commit('setCityCode', parseInt(result.adcode))

            //逆向地理编码
            AMap.plugin('AMap.Geocoder', function() {
              var geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: result.adcode
              })

              var lnglat = result.rectangle.split(';')[0].split(',')

              geocoder.getAddress(lnglat, function(status, data) {
                if (status === 'complete' && data.info === 'OK') {
                  // result为对应的地理位置详细信息
                  console.log(data)
                  self.$store.commit('setCity', data.regeocode.addressComponent.city)
                  self.$store.commit('setCityCode', parseInt(data.regeocode.addressComponent.adcode))
                  localStorage.setItem('cityCode', parseInt(data.regeocode.addressComponent.adcode))
                  localStorage.setItem('cityName', data.regeocode.addressComponent.city)
                }
              })
            })
          }
        })
      })
    },
    callback() {
      console.log(111)
    }
  }
}
</script>
<style lang="less">
.home {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  .box {
    width: 100vw;
    height: 100vh;
  }
  .swiper-container {
    width: 100%;
    height: 100vh;
  }
  /*版心*/
  @media screen and (min-width: 1440px) {
    // 首页标题
    .title {
      font-size: 60px;
    }
    .first .word {
      .xthk-word {
        width: 253px;
      }
      .more {
        width: 224px;
        height: 56px;
        line-height: 56px;
      }
    }

    // 首页文字
    .first .desc,
    .second .desc {
      font-size: 24px;
    }
    // 第三屏样式
  }
  @media screen and (max-width: 1440px) and (min-width: 1280px) {
    .title {
      font-size: 48px;
      margin-top: 15px;
    }
    .first .word {
      .xthk-word {
        width: 202px;
      }
      .more {
        width: 179px;
        height: 45px;
        line-height: 45px;
      }
    }

    // 首页文字
    .first .desc,
    .second .desc {
      font-size: 18px;
    }
  }
  @media screen and (max-width: 1280px) {
    .title {
      font-size: 48px;
      margin-top: 15px;
    }
    .first .word {
      .xthk-word {
        width: 202px;
      }
      .more {
        width: 179px;
        height: 45px;
        line-height: 45px;
      }
    }

    // 首页文字
    .first .desc,
    .second .desc {
      font-size: 18px;
    }

    // 第四屏
    .four .con .title {
      margin-top: 0;
    }
  }
}
</style>
